import type { FC } from 'react';

/** Placeholder keeping a section's height when its category has no licensed objects. */
export const NoBreakdownData: FC = () => (
  <div className='flex h-32 items-center justify-center text-plain'>
    No data
  </div>
);
